import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex w-full flex-col h-full text-gray-theme-500 text-sm"
}
const _hoisted_2 = { class: "flex-shrink-0 flex gap-2 pr-10 h-15 pl-10 items-center justify-between font-light" }
const _hoisted_3 = { class: "flex items-center gap-6" }
const _hoisted_4 = { class: "flex items-center pr-2 gap-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 items-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Back to conversation"),
  /*#__PURE__*/_createElementVNode("div", { class: "rounded-md button-bg rounded-md px-1 py-0.5" }, " Esc ")
], -1)
const _hoisted_6 = { class: "flex items-center gap-3 whitespace-nowrap overflow-hidden overflow-ellipsis" }
const _hoisted_7 = {
  key: 2,
  class: "whitespace-nowrap overflow-hidden overflow-ellipsis"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "|", -1)
const _hoisted_9 = { class: "capitalize" }
const _hoisted_10 = { class: "ml-auto flex items-center gap-2" }
const _hoisted_11 = {
  key: 0,
  class: "flex items-center justify-center absolute left-0 right-0 bottom-0 top-0"
}
const _hoisted_12 = { class: "flex gap-3 items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "rounded-md button-bg rounded-md px-1 py-0.5" }, " U ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center px-1 gap-2 whitespace-nowrap" }, " Move message ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 items-center whitespace-nowrap" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Move message"),
  /*#__PURE__*/_createElementVNode("div", { class: "rounded-md button-bg rounded-md px-1 py-0.5" }, " M ")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center px-1 gap-2" }, " Reply ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 items-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Reply"),
  /*#__PURE__*/_createElementVNode("div", { class: "rounded-md button-bg rounded-md px-1 py-0.5" }, " R ")
], -1)
const _hoisted_18 = {
  key: 0,
  class: "flex items-center justify-center absolute left-0 right-0 bottom-0 top-0"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 items-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Delete"),
  /*#__PURE__*/_createElementVNode("div", { class: "rounded-md button-bg rounded-md px-1 py-0.5" }, " # ")
], -1)
const _hoisted_20 = { class: "overflow-y-auto overflow-x-hidden h-full flex flex-col scrollbar relative" }
const _hoisted_21 = {
  key: 0,
  class: "absolute top-0 left-0 bottom-0 right-0 flex flex-col gap-4 pt-4 items-center justify-center h-32 z-1 bg-white"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-theme-500" }, " Loading email...", -1)
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "px-10" }
const _hoisted_25 = {
  key: 3,
  class: "py-4 px-10 flex gap-3"
}
const _hoisted_26 = { class: "min-h-5 min-w-5" }

import { onMounted, watch, ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useMessages } from '../composition';
import {
	Tooltip,
	SvgIcon,
	BorderedButton,
	UiLoader,
	useUiState
} from '@/ui-kit';
import EmailFullMessage from './components/EmailFullMessage.vue';
import MessageDetailsHeader from './components/MessageDetailsHeader.vue';
import { useContacts } from '@/contacts';
import CallFullMessage from './components/CallFullMessage.vue';
import ShortMessageIcons from './components/ShortMessageIcons.vue';
import MediaList from './components/MediaList.vue';
import ReplyInput from './components/ReplyInput.vue';
import { useToast } from 'vue-toastification';
import { useMoveMessage } from './use-move-message';
import { downloadFile } from '@/utils';
import { whenever } from '@vueuse/shared';
import {
	useActiveElement,
	useMagicKeys
} from '@vueuse/core';
import { useConversationsActions } from './use-conversations-action';
import {
	MessageRoutableSyncButton,
	AppfolioButton
} from '@/interations';


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageDetails',
  setup(__props) {

const {
	loadMessageDetails,
	selectedMessage,
	setSelectedMessage,
	selectedMessageDetails,
	setMessageRead,
	setMessageUnread,
	deleteMessage,
	isDeletingMessage,
	isUpdatingMessage
} = useMessages();
const { selectedContact } = useContacts();
const route = useRoute();
const router = useRouter();
const reply = ref(route.params.reply?.toString() === '1');
const { openDialog } = useMoveMessage();
const { backspace, r, escape } = useMagicKeys();
const ui = useUiState();
const { setMessageActions } = useConversationsActions();

async function showReply() {
	reply.value = true;
}

onMounted(() => {
	setMessageActions();
});

const activeElement = useActiveElement();

whenever(
	() => {
		const tagName = activeElement.value?.tagName;
		return (
			escape.value &&
			ui.isNoDialogAndDropdown &&
			tagName !== 'INPUT' &&
			tagName !== 'TEXTAREA' &&
			tagName !== 'SELECT' &&
			!activeElement.value?.classList.contains(
				'ck'
			) &&
			!activeElement.value?.getAttribute(
				'contenteditable'
			) &&
			reply.value
		);
	},
	() => {
		reply.value = false;
	}
);

whenever(
	() => {
		const tagName = activeElement.value?.tagName;
		return (
			r.value &&
			ui.isNoDialogAndDropdown &&
			tagName !== 'INPUT' &&
			tagName !== 'TEXTAREA' &&
			tagName !== 'SELECT' &&
			!activeElement.value?.classList.contains(
				'ck'
			) &&
			!activeElement.value?.getAttribute(
				'contenteditable'
			) &&
			selectedMessage.value?.type === 'email'
		);
	},
	() => {
		showReply();
	}
);

whenever(
	() => {
		const tagName = activeElement.value?.tagName;
		return (
			backspace.value &&
			ui.isNoDialogAndDropdown &&
			tagName !== 'INPUT' &&
			tagName !== 'TEXTAREA' &&
			tagName !== 'SELECT' &&
			!activeElement.value?.classList.contains(
				'ck'
			) &&
			!activeElement.value?.getAttribute(
				'contenteditable'
			)
		);
	},
	() => {
		router.push({
			name: 'ConversationDetails',
			params: route.params
		});
	}
);

onMounted(async () => {
	if (selectedMessage.value?.type !== 'email') {
		return;
	}

	if (selectedMessageDetails.value) {
		return setSelectedMessage(
			selectedMessageDetails.value
		);
	}

	const message = await loadMessageDetails(
		route.params.leadId as string,
		route.params.messageUid as string
	);
	setSelectedMessage(message);
});

function toggleRead() {
	if (!selectedMessage.value) {
		return;
	}

	if (selectedMessage.value.read_at) {
		return setMessageUnread(
			selectedMessage.value.conversation_id,
			selectedMessage.value
		);
	}

	setMessageRead(
		selectedMessage.value.conversation_id,
		selectedMessage.value
	);
}

const { warning } = useToast();
const { moveLoading } = useMoveMessage();

onMounted(() => {
	if (
		selectedMessage.value &&
		!selectedMessage.value.read_at &&
		selectedMessage.value.content.direction ===
			'incoming'
	) {
		setMessageRead(
			selectedMessage.value.conversation_id,
			selectedMessage.value
		);
	}
});

watch(selectedMessage, () => {
	if (!selectedMessage.value && !moveLoading.value) {
		warning('Message was deleted.');
		return router.replace({
			name: 'ConversationDetails',
			params: route.params
		});
	} else {
		setMessageActions();
	}
});

const status = computed(
	() =>
		selectedMessage.value?.content?.status?.replace(
			/[. _]/gm,
			' '
		) || selectedMessage.value?.status
);

const deliveryDate = computed(() => {
	if (
		selectedMessage.value &&
		'expected_delivery_date' in
			selectedMessage.value.content &&
		selectedMessage.value.content
			?.expected_delivery_date
	) {
		const [year, month, day] =
			selectedMessage.value.content?.expected_delivery_date.split(
				'-'
			);

		return `${day}/${month}/${year}`;
	}

	return null;
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_unref(selectedMessage))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Tooltip), { placement: "bottom" }, {
              popper: _withCtx(() => [
                _hoisted_5
              ]),
              default: _withCtx(() => [
                _createVNode(_component_RouterLink, { to: {
							name: 'ConversationDetails'
						} }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BorderedButton), null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_unref(SvgIcon), {
                            name: "BackArrowIcon",
                            class: "h-3 w-3"
                          }),
                          _createTextVNode(" Back ")
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(ShortMessageIcons, { message: _unref(selectedMessage) }, null, 8, ["message"]),
              (
							!_unref(selectedMessage)?.content
								?.records?.length ||
							_unref(selectedMessage)?.content
								.records[0].type !==
								'voicemail'
						)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_unref(selectedMessage)?.content
								.direction === 'incoming' ||
							_unref(selectedMessage)?.content
								.direction === 'in' ||
							_unref(selectedMessage)?.content
								.direction === 'inbound'
								? 'Inbound'
								: 'Outbound') + " " + _toDisplayString(_unref(selectedMessage)?.type.replace(
								'-',
								' '
							)), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Voicemail ")
                  ], 64)),
              (
							_unref(selectedMessage) &&
							(_unref(selectedMessage).type ===
								'fax' ||
								_unref(selectedMessage).type ===
									'physical-mail')
						)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _hoisted_8,
                    _createTextVNode(" Status : "),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(status)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_unref(deliveryDate))
              ? (_openBlock(), _createBlock(_unref(Tooltip), {
                  key: 0,
                  placement: "bottom",
                  delay: { show: 0, hide: 0 }
                }, {
                  popper: _withCtx(() => [
                    _createTextVNode(" Expected delivery date " + _toDisplayString(_unref(deliveryDate)), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(SvgIcon), {
                      class: "h-4 w-4 text-inbox-gray-theme-600",
                      name: "calendar"
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (
						_unref(selectedMessage).type === 'fax' ||
						(_unref(selectedMessage).type ===
							'text-message' &&
							_unref(selectedMessage).media.length)
					)
              ? (_openBlock(), _createBlock(_unref(AppfolioButton), {
                  key: 1,
                  id: 
						_unref(selectedMessage).content.id ||
						_unref(selectedMessage).id
					,
                  type: 
						_unref(selectedMessage).type === 'fax'
							? 'faxes'
							: 'sms'
					
                }, null, 8, ["id", "type"]))
              : _createCommentVNode("", true),
            (
						_unref(selectedMessage).type === 'fax' ||
						(_unref(selectedMessage).type ===
							'text-message' &&
							_unref(selectedMessage).media.length)
					)
              ? (_openBlock(), _createBlock(_unref(MessageRoutableSyncButton), {
                  key: 2,
                  id: 
						_unref(selectedMessage).content.id ||
						_unref(selectedMessage).id
					,
                  type: 
						_unref(selectedMessage).type === 'fax'
							? 'faxes'
							: 'sms'
					
                }, null, 8, ["id", "type"]))
              : _createCommentVNode("", true),
            (
						_unref(selectedMessage)?.content
							.direction === 'incoming'
					)
              ? (_openBlock(), _createBlock(_unref(Tooltip), {
                  key: 3,
                  placement: "bottom"
                }, {
                  popper: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", null, _toDisplayString(_unref(selectedMessage).read_at
									? 'Mark as unread'
									: 'Mark as read'), 1),
                      _hoisted_13
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(BorderedButton), {
                      class: "relative",
                      onClick: toggleRead,
                      disabled: 
							_unref(isUpdatingMessage)(
								_unref(selectedMessage).uid
							)
						
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["flex items-center px-1 gap-2", {
								'opacity-0':
									_unref(isUpdatingMessage)(
										_unref(selectedMessage).uid
									)
							}])
                        }, _toDisplayString(_unref(selectedMessage).read_at
									? 'Mark as unread'
									: 'Mark as read'), 3),
                        (
								_unref(isUpdatingMessage)(
									_unref(selectedMessage).uid
								)
							)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(_unref(UiLoader))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(Tooltip), { placement: "bottom" }, {
              popper: _withCtx(() => [
                _hoisted_15
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(BorderedButton), {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openDialog)(_unref(selectedMessage))))
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_unref(selectedMessage).type === 'email')
              ? (_openBlock(), _createBlock(_unref(Tooltip), {
                  key: 4,
                  placement: "bottom"
                }, {
                  popper: _withCtx(() => [
                    _hoisted_17
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(BorderedButton), {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (showReply()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(Tooltip), { placement: "bottom" }, {
              popper: _withCtx(() => [
                _hoisted_19
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(BorderedButton), {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (
							_unref(deleteMessage)(_unref(selectedMessage))
						)),
                  class: "relative"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex items-center px-1 gap-2", {
								'opacity-0':
									_unref(isDeletingMessage)(
										_unref(selectedMessage).uid
									)
							}])
                    }, " Delete ", 2),
                    (
								_unref(isDeletingMessage)(
									_unref(selectedMessage).uid
								)
							)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(_unref(UiLoader))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        (_unref(selectedMessage) && _unref(selectedContact))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(MessageDetailsHeader, {
                class: "mt-4",
                message: _unref(selectedMessage),
                contact: _unref(selectedContact)
              }, null, 8, ["message", "contact"]),
              _createElementVNode("div", _hoisted_20, [
                (_unref(selectedMessage).type === 'email')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!_unref(selectedMessageDetails))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _hoisted_22,
                            _createVNode(_unref(UiLoader))
                          ]))
                        : (_openBlock(), _createBlock(EmailFullMessage, {
                            key: 1,
                            message: _unref(selectedMessageDetails),
                            messageDetails: 
							_unref(selectedMessageDetails)
						
                          }, null, 8, ["message", "messageDetails"]))
                    ], 64))
                  : _createCommentVNode("", true),
                (_unref(selectedMessage).type === 'call')
                  ? (_openBlock(), _createBlock(CallFullMessage, {
                      key: 1,
                      class: "mb-4",
                      message: _unref(selectedMessage)
                    }, null, 8, ["message"]))
                  : _createCommentVNode("", true),
                (
						_unref(selectedMessage).type ===
						'text-message'
					)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("div", {
                        class: "py-4 px-10",
                        innerHTML: _unref(selectedMessage).body
                      }, null, 8, _hoisted_23),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(MediaList, {
                          media: _unref(selectedMessage).media
                        }, null, 8, ["media"])
                      ])
                    ], 64))
                  : (
						_unref(selectedMessage).type === 'fax' ||
						_unref(selectedMessage).type ===
							'physical-mail'
					)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedMessage).media, (media) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "inline-flex items-center gap-4 detail p-2",
                            key: media.name
                          }, [
                            _createElementVNode("div", null, _toDisplayString(media.file_name), 1),
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_unref(SvgIcon), {
                                onClick: ($event: any) => (
									_unref(downloadFile)(
										media.original_url
									)
								),
                                class: "cursor-pointer h-4 w-4 transition opacity-50 hover:opacity-100",
                                name: "download"
                              }, null, 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (reply.value)
              ? (_openBlock(), _createBlock(ReplyInput, {
                  key: 0,
                  contact: _unref(selectedContact),
                  message: _unref(selectedMessage),
                  onClose: _cache[3] || (_cache[3] = ($event: any) => (reply.value = false))
                }, null, 8, ["contact", "message"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})